import { visionURL } from "../config/environment";
import JsonApiService from "../services/jsonapiService";
import visionCallService from "../services/visionCallService";

const contentRepositoryAttachablesApiService = new JsonApiService(
  "content_repository_attachables",
  {
    baseUrl: `${visionURL}/admin_console/api/content`,
    credentials: "include"
  }
);

export const useContentRepositoryAttachables = () => {
  const batchCreate = async contentRepositoryAttachables => {
    const operations = contentRepositoryAttachables
      ? contentRepositoryAttachables.map(contentRepositoryAttachable => {
          return visionCallService.serializeAtomicOperation(
            contentRepositoryAttachable,
            "contentRepositoryAttachable",
            "add",
            ["attached", "contentRepositoryItem"]
          );
        })
      : [];
    const response = await contentRepositoryAttachablesApiService.operations(
      operations
    );
    const operationData = await response.json();

    if (operationData.errors) {
      throw operationData.errors;
    }

    return visionCallService.deserializeAtomicResults(operationData);
  };

  const destroy = contentRepositoryAttachableId => {
    return contentRepositoryAttachablesApiService.delete(
      contentRepositoryAttachableId
    );
  };

  return {
    batchCreate,
    destroy
  };
};
